import React, { useState } from 'react';
import { FaCopy, FaShare, FaCheck, FaTimes } from 'react-icons/fa';

function EnterpriseUserPasswordResetModal({ show, onClose, userAccount, resetPassword }) {
  const [copiedField, setCopiedField] = useState(null);

  if (!show || !userAccount || !resetPassword) return null;

  const copyToClipboard = async (text, field) => {
    try {
      await navigator.clipboard.writeText(text);
      setCopiedField(field);
      setTimeout(() => setCopiedField(null), 2000);
    } catch (err) {
      console.error('Failed to copy: ', err);
    }
  };

  const copyCredentials = async () => {
    const credentials = `Username: ${userAccount.email}\nPassword: ${resetPassword}`;
    await copyToClipboard(credentials, 'both');
  };

  const shareCredentials = () => {
    const subject = `Login Credentials for ${userAccount.name}`;
    const body = `Hello ${userAccount.name},

Your login credentials have been reset:

Username: ${userAccount.email}
Temporary Password: ${resetPassword}

Please log in and change your password immediately upon first login.

Best regards`;

    const mailtoUrl = `mailto:?subject=${encodeURIComponent(subject)}&body=${encodeURIComponent(body)}`;
    window.open(mailtoUrl);
  };

  return (
    <div className="modal fade show" style={{ display: 'block', backgroundColor: 'rgba(0,0,0,0.5)' }}>
      <div className="modal-dialog modal-dialog-centered">
        <div className="modal-content">
          <div className="modal-header bg-success text-white">
            <h5 className="modal-title">
              <FaCheck className="me-2" />
              Password Reset Successful
            </h5>
            <button 
              type="button" 
              className="btn-close btn-close-white" 
              onClick={onClose}
              aria-label="Close"
            ></button>
          </div>
          <div className="modal-body">
            <div className="alert alert-success mb-4">
              <strong>Password has been reset successfully!</strong>
              <p className="mb-0 mt-2">
                Please share these credentials with <strong>{userAccount.name}</strong> and 
                ask them to change the password on first login.
              </p>
            </div>
            
            <div className="row g-3">
              <div className="col-12">
                <label className="form-label fw-bold">Username:</label>
                <div className="input-group">
                  <input 
                    type="text" 
                    className="form-control" 
                    value={userAccount.email} 
                    readOnly 
                  />
                  <button 
                    className="btn btn-outline-secondary" 
                    type="button"
                    onClick={() => copyToClipboard(userAccount.email, 'username')}
                    title="Copy username"
                  >
                    {copiedField === 'username' ? (
                      <FaCheck className="text-success" />
                    ) : (
                      <FaCopy />
                    )}
                  </button>
                </div>
              </div>
              
              <div className="col-12">
                <label className="form-label fw-bold">Temporary Password:</label>
                <div className="input-group">
                  <input 
                    type="text" 
                    className="form-control font-monospace" 
                    value={resetPassword} 
                    readOnly 
                  />
                  <button 
                    className="btn btn-outline-secondary" 
                    type="button"
                    onClick={() => copyToClipboard(resetPassword, 'password')}
                    title="Copy password"
                  >
                    {copiedField === 'password' ? (
                      <FaCheck className="text-success" />
                    ) : (
                      <FaCopy />
                    )}
                  </button>
                </div>
              </div>
            </div>

            {copiedField && (
              <div className="alert alert-success mt-3 mb-0">
                <small>
                  {copiedField === 'both' ? 'Credentials copied to clipboard!' :
                   copiedField === 'username' ? 'Username copied to clipboard!' :
                   'Password copied to clipboard!'}
                </small>
              </div>
            )}
          </div>
          <div className="modal-footer">
            <div className="d-flex gap-2 w-100">
              <button 
                type="button" 
                className="btn btn-primary flex-fill" 
                onClick={copyCredentials}
              >
                <FaCopy className="me-2" />
                Copy Both
              </button>
              <button 
                type="button" 
                className="btn btn-info flex-fill" 
                onClick={shareCredentials}
              >
                <FaShare className="me-2" />
                Share via Email
              </button>
              <button 
                type="button" 
                className="btn btn-secondary" 
                onClick={onClose}
              >
                <FaTimes className="me-2" />
                Close
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default EnterpriseUserPasswordResetModal;
